import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function HandBags({ componentData, getTargetUrl }) {
  return (
    <section className="handbag spacer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="main-heading-center mt-30">
              <h4>{componentData?.heading || ""}</h4>
            </div>
          </div>
        </div>
      </div>
      {componentData.data?.map((data, index) => {
        return (
          <Link to={getTargetUrl(data)} key={"handbagcollink" + index}>
            <div className="handbag-box mt-40"  key={"handbagcol" + index}>
              <div className="row align-items-center">
                {/* <div className="col-lg-4 col-md-2 col-2">
                  <div className="text-box text-center">
                    <h4>{data?.title || ""}</h4>
                  </div>
                </div> */}
                <div className="col">
                  <div className="handbag-photo">
                    <LazyLoadImage
                      alt={""}
                      effect="blur"
                      src={data?.src || ""}
                      className="img-fluid mx-auto d-block"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        );
      })}
    </section>
  );
}

export default HandBags;
